export default {
      id: "icon-recurring-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-recurring",
      toString: function () {
        return this.url;
      }
    }